import React from 'react';
import TextEditor from '../TextEditor';
import useEditorContext from '../../../hooks/useEditorContext';
import { Heading, Icon, EditorContainer, fieldType } from './helpers';

export default function TextField({ field }) {
  const { historyMode, readOnlyMode } = useEditorContext();
  const content = field.editorBackendContent;

  return (
    <React.Fragment>
      <Heading>
        <Icon type="font" />
        { field.name }
      </Heading>
      {content && (
        <EditorContainer>
          <TextEditor
            storyId={field.storyId}
            contentEditorId={content.uuid}
            contentId={parseInt(content.id, 10)}
            historyMode={historyMode}
            readOnlyMode={readOnlyMode}
            format={field.contentType}
            fieldTemplateId={field.fieldTemplateId}
            fieldTemplate={field.fieldTemplate}
          />
        </EditorContainer>
      )}
    </React.Fragment>
  );
}

TextField.propTypes = {
  field: fieldType.isRequired
}



// WEBPACK FOOTER //
// ./app/javascript/client/components/textEditor/customFields/TextField.jsx